import Vue from 'vue'

import el from '@/el'
import i18n from '@/i18n'
import render from '@/render'
import router from '@/router'
import store from '@/store'

new Vue({ // eslint-disable-line no-new
  el,
  i18n,
  render,
  router,
  store
})
